import { ERoles } from '@/auth/constants';
import { BackkdropLoader } from '@/components/backdroploader';
import { PermWrapper } from '@/components/permwrapper';
import { Unauthorized } from '@/components/unauthorized';
import React from 'react';
import { Suspense } from 'react';
import { Route } from 'react-router-dom';

const ScheduledActions = React.lazy(
	() => import('@/views/schedule/actions/main')
);

export const ScheduleRoutes = (
	<>
		<Route
			path='/schedule/actions'
			element={
				<Suspense fallback={<BackkdropLoader />}>
					<PermWrapper
						allowedRoles={[
							ERoles.ADMIN,
							ERoles.SCHEDULE_MANAGER,
							ERoles.SCHEDULE_READONLY
						]}
						fallback={<Unauthorized />}>
						<ScheduledActions />
					</PermWrapper>
				</Suspense>
			}
		/>
	</>
);
